import React, { useState } from 'react';

import { Action } from 'shared/types';
import { Tab } from 'retired/Tab';
import { isDateInThePast } from 'utils/dateTime';
import Organization from 'entities/organization/model';

import { ActionTable } from './ActionTable';

const tabStyle = {
  fontSize: 12,
  paddingBottom: 3,
};

export const ActionResults = ({
  actions,
  isLoading,
  organization,
  actionsTotal,
  actionsPage,
  actionsLimit,
  handlePageChange,
  handleRowsPerPageChange,
}: {
  actions: Action[];
  isLoading: boolean;
  organization: Organization;
  actionsTotal: number;
  actionsPage: number;
  actionsLimit: number;
  handlePageChange: (event: unknown, newPage: number) => void;
  handleRowsPerPageChange: (event: any) => void;
}) => {
  const [showInactive, setShowInactive] = useState(false);

  const filteredActions =
    actions?.filter((action) => {
      if (showInactive) {
        return (
          action.enabled === false ||
          isDateInThePast(action.endingAt) ||
          action.status === 'archived'
        );
      }

      return (
        action.enabled === true && !isDateInThePast(action.endingAt) && action.status !== 'archived'
      );
    }) || [];

  if (isLoading) {
    return null;
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Tab
          style={tabStyle}
          text="Active"
          isActive={!showInactive}
          onClick={() => setShowInactive(false)}
        />
        <Tab
          style={tabStyle}
          text="Inactive"
          isActive={showInactive}
          onClick={() => setShowInactive(true)}
        />
      </div>
      <ActionTable
        actions={filteredActions}
        organization={organization}
        showInactive={showInactive}
        actionsTotal={actionsTotal}
        actionsPage={actionsPage}
        actionsLimit={actionsLimit}
        handlePageChange={handlePageChange}
        handleRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
};
